import { Routes } from '@angular/router';
import { SigningErrorPagePath } from '@app/shared/types/signing-error-page-path.enum';
import { ERROR_ROUTE } from '@shared/types/error-route.const';
import { ERROR_TYPE_PARAM } from './pages/error/error-page-translation-key.map';
import { signerDataResolver } from './resolvers/signer-data.resolver';
import { approverDataResolver } from './resolvers/approver-data.resolver';
import { legacySigningResolver } from './resolvers/legacy-signing.resolver';
import { secureUploadExternalResolver } from './resolvers/secure-upload-external.resolver';
import { orderContextGuard } from './guards/order-context.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    resolve: { data: legacySigningResolver },
    loadComponent: () => import('./pages/signing/signing-page').then((m) => m.SigningPage),
  },
  {
    path: 'Blanket/SikkerUpload',
    pathMatch: 'full',
    resolve: { data: secureUploadExternalResolver },
    loadComponent: () => import('./pages/signing/signing-page').then((m) => m.SigningPage),
  },
  {
    path: 'Blanket/SikkerUpload/:id',
    pathMatch: 'full',
    resolve: { data: secureUploadExternalResolver },
    loadComponent: () => import('./pages/signing/signing-page').then((m) => m.SigningPage),
  },
  {
    path: 'order/:orderId/signer/:signerId',
    children: [
      {
        path: '',
        resolve: { data: signerDataResolver },
        loadComponent: () => import('./pages/signing/signing-page').then((m) => m.SigningPage),
      },
      {
        path: 'receipt',
        canActivate: [orderContextGuard],
        loadComponent: () => import('./pages/receipt/receipt-page').then((m) => m.ReceiptPage),
      },
      {
        path: 'download',
        canActivate: [orderContextGuard],
        loadComponent: () => import('./pages/download/download-page').then((m) => m.DownloadPage),
      },
    ],
  },
  {
    path: 'approve',
    resolve: { data: approverDataResolver },
    children: [
      {
        path: '',
        loadComponent: () => import('./pages/approver/approver-page').then((m) => m.ApproverPage),
      },
      {
        path: 'receipt',
        loadComponent: () =>
          import('./pages/approver/approver-receipt/esignatur-approver-receipt').then(
            (m) => m.EsignaturApproverReceipt
          ),
      },
    ],
  },
  {
    path: `${ERROR_ROUTE}/:${ERROR_TYPE_PARAM}`,
    loadComponent: () => import('./pages/error/error-page').then((m) => m.ErrorPage),
  },
  {
    path: '**',
    redirectTo: `${ERROR_ROUTE}/${SigningErrorPagePath.NotFound}`,
  },
];
